import api from './base/standardApi';

const DocsRequestApi = {
  getDocRequests( accountId: string, params?: any ) {
    return api.get( `api/solicitud-doc/GetAllByCuentaInversionId/${accountId}`, params );
  },
  getDocRequestsById( accountId: number, docRequestId: number, params?: any ) {
    return api.get( `api/solicitud-doc/GetById/${accountId}/${docRequestId}`, params );
  },
  getFileById( accountId: string, docRequestId: string, params?: any ) {
    return api.get( `api/solicitud-doc/GetDocumentBySolicitudId/${accountId}/${docRequestId}`, params );
  },
  postFileByUrl( accountId: number, urlFile: string ) {
    const formData = new FormData();
    formData.append( 'url', urlFile );

    return api.post( `api/solicitud-doc/GetDocumentByUrl/${String( accountId )}`, formData );
  },
  editDocRequests( docRequestId: number, data:any ) {
    return api.put( `api/solicitud-doc/Update/${docRequestId}`, data );
  },
  createDocRequest( data:any ) {
    return api.post( 'api/solicitud-doc/Create/', data );
  },
  uploadDocRequestFile( accountId: number, docRequestId: number, data: any ) {
    const formData = new FormData();
    formData.append( 'file', data.file );
    formData.append( 'nota', data.nota );

    return api.post( `api/solicitud-doc/UpdateFile/${accountId}/${docRequestId}`, formData );
  },
  getAllDocRequests( params?: any ) {
    return api.get( 'api/solicitud-doc/GetAll', params );
  },

};

export default DocsRequestApi;
